import { render } from "./SidePage.vue?vue&type=template&id=84e9401e&scoped=true"
import script from "./SidePage.vue?vue&type=script&lang=js"
export * from "./SidePage.vue?vue&type=script&lang=js"

import "./SidePage.vue?vue&type=style&index=0&id=84e9401e&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e9401e"]])

export default __exports__